import { useContext, useRef, useEffect } from 'react';
import FormContext$1 from './FormContext.js';
import { fieldFormState } from './utils.js';

/**
 * A hook to run an effect when form fields change
 * @param {function} effect Effect function, can optionally return a 'clean-up' function
 * @param {string[]} triggerFields Array of field names to trigger the effect on, or an empty array to fire on form initialisation, or omit to trigger on any field change
 */

var useFormEffect = function useFormEffect(effect, triggerFields) {
  var context = useContext(FormContext$1);
  var prevContext = useRef();
  var cleanup = useRef();
  useEffect(function () {
    var triggered = !triggerFields || triggerFields.some(function (f) {
      var _prevContext$current;

      return prevContext.current && context.value[f] !== ((_prevContext$current = prevContext.current) === null || _prevContext$current === void 0 ? void 0 : _prevContext$current.value[f]);
    });

    if (triggered) {
      if (cleanup.current) {
        var _prevContext$current2;

        cleanup.current(fieldFormState((_prevContext$current2 = prevContext.current) !== null && _prevContext$current2 !== void 0 ? _prevContext$current2 : context));
      }

      cleanup.current = effect(fieldFormState(context));
    }

    prevContext.current = context;
  }, [context.value]);
  useEffect(function () {
    if ((triggerFields === null || triggerFields === void 0 ? void 0 : triggerFields.length) === 0) {
      cleanup.current = effect(fieldFormState(context));
    }

    return function () {
      if (cleanup.current) {
        var _prevContext$current3;

        cleanup.current(fieldFormState((_prevContext$current3 = prevContext.current) !== null && _prevContext$current3 !== void 0 ? _prevContext$current3 : context));
      }
    };
  }, []);
};

var useFormEffect$1 = useFormEffect;

export { useFormEffect$1 as default };
